export const Modal = {
  parts: ['header', 'body'],
  baseStyle: {
    fontFamily: 'body',
    header: {
      fontFamily: 'heading',
      fontWeight: 'bold',
      px: 8,
      pt: 6,
      pb: 2,
    },
    body: {
      py: 6,
      px: 8,
    },
  },
};
